<template>
  <v-app>
    <v-stepper v-model="e1" class="quiz-wrapper elevation-0">
      <v-stepper-items>
        <v-stepper-content step="1" class="quiz-start">
          <v-row>
            <v-col cols="12" md="5" class="order-sm-2 d-flex img-col order-md-1">
              <img src="../assets/s1.png" alt="Deloitte CaseAcademy">
            </v-col>
            <v-col cols="12" md="7" class="d-flex txt-col order-sm-1 order-md-2">
<!--              <div class="header">
                <v-row>
                  <v-col cols="12" class="d-flex">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 75.002"><defs><clipPath id="a"><path data-name="Rectangle 2" transform="translate(0 -.002)" fill="none" d="M0 0h300v75.002H0z"/></clipPath></defs><g data-name="Vector Smart Object"><g data-name="Group 2"><g data-name="Group 1" clip-path="url(#a)" transform="translate(0 .002)"><path data-name="Path 1" d="M14.661 7.255a6.693 6.693 0 0 0-5.79 2.883q-2.055 2.88-2.055 8.035 0 10.718 7.845 10.715a24.291 24.291 0 0 0 7.972-1.688v5.7a21.614 21.614 0 0 1-8.591 1.644q-6.82 0-10.433-4.241T0 18.126a20.337 20.337 0 0 1 1.771-8.759 13.035 13.035 0 0 1 5.1-5.761 14.77 14.77 0 0 1 7.79-2.006 20.63 20.63 0 0 1 9.15 2.259l-2.137 5.524a35.421 35.421 0 0 0-3.527-1.494 10.366 10.366 0 0 0-3.486-.635" fill="#86bc25"/><path data-name="Path 2" d="m43.946 34.108-1.264-3.331h-.172a9.662 9.662 0 0 1-3.385 2.946 10.731 10.731 0 0 1-4.542.822 7.215 7.215 0 0 1-5.415-2.019 7.85 7.85 0 0 1-1.979-5.74 6.538 6.538 0 0 1 2.659-5.756q2.664-1.85 8.028-2.045l4.146-.135v-1.073q0-3.724-3.72-3.726a16.669 16.669 0 0 0-6.734 1.775l-2.157-4.517A19.074 19.074 0 0 1 38.562 9.1q4.8 0 7.373 2.149t2.565 6.528v16.33Zm-1.923-11.356-2.522.088a7.9 7.9 0 0 0-4.232 1.051 3.344 3.344 0 0 0-1.39 2.935q0 2.834 3.161 2.831a4.96 4.96 0 0 0 3.628-1.337 4.787 4.787 0 0 0 1.355-3.554Z" fill="#86bc25"/><path data-name="Path 3" d="M71.882 26.827a6.829 6.829 0 0 1-2.553 5.745q-2.558 1.967-7.642 1.972a23.5 23.5 0 0 1-4.445-.364 16.249 16.249 0 0 1-3.442-1.061v-5.527a22.043 22.043 0 0 0 4.09 1.473 16.391 16.391 0 0 0 4.009.588c2.365 0 3.547-.7 3.547-2.1a1.79 1.79 0 0 0-.467-1.28 6.714 6.714 0 0 0-1.629-1.119c-.766-.416-1.791-.906-3.075-1.457a19.352 19.352 0 0 1-4.05-2.191 6.172 6.172 0 0 1-1.883-2.316 7.823 7.823 0 0 1-.589-3.211 5.868 5.868 0 0 1 2.471-5.053q2.466-1.788 7-1.785a19.458 19.458 0 0 1 8.4 1.931l-1.964 4.819A34.9 34.9 0 0 0 66.3 14.6a10.233 10.233 0 0 0-3.187-.5q-2.885 0-2.882 1.6a1.888 1.888 0 0 0 .929 1.556 24.239 24.239 0 0 0 4.07 1.952 18.921 18.921 0 0 1 4.105 2.17 6.4 6.4 0 0 1 1.923 2.326 7.314 7.314 0 0 1 .619 3.133" fill="#86bc25"/><path data-name="Path 4" d="M87.781 34.545q-5.77 0-9.018-3.268t-3.248-9.248q0-6.159 3-9.524a10.566 10.566 0 0 1 8.307-3.367q5.062 0 7.886 2.961t2.821 8.176v3.242H82.117a6.53 6.53 0 0 0 1.644 4.45 5.708 5.708 0 0 0 4.318 1.6 17.508 17.508 0 0 0 4.085-.458 20.18 20.18 0 0 0 4.014-1.468v5.173a14.861 14.861 0 0 1-3.654 1.3 22.349 22.349 0 0 1-4.745.432m-.919-20.65a4.076 4.076 0 0 0-3.248 1.348 6.343 6.343 0 0 0-1.35 3.825h9.15a5.653 5.653 0 0 0-1.258-3.825 4.217 4.217 0 0 0-3.293-1.348" fill="#86bc25"/><path data-name="Path 5" d="m122.471 34.108-2.263-7.629h-11.393l-2.268 7.629h-7.135l11.027-32.177h8.1l11.071 32.177Zm-3.847-13.328q-3.144-10.367-3.537-11.725a35.349 35.349 0 0 1-.568-2.149q-.7 2.8-4.039 13.874Z" fill="#86bc25"/><path data-name="Path 6" d="M142.733 34.545q-11.159 0-11.159-12.558 0-6.253 3.035-9.55t8.7-3.3a16.191 16.191 0 0 1 7.434 1.671l-1.923 5.173q-1.538-.64-2.862-1.046a9.165 9.165 0 0 0-2.649-.4q-5.092 0-5.09 7.405 0 7.189 5.09 7.192a11.3 11.3 0 0 0 3.481-.515A12.37 12.37 0 0 0 150 27v5.719a10.326 10.326 0 0 1-3.2 1.426 17.383 17.383 0 0 1-4.07.4" fill="#86bc25"/><path data-name="Path 7" d="m170.71 34.108-1.258-3.331h-.173a9.674 9.674 0 0 1-3.39 2.946 10.731 10.731 0 0 1-4.542.822 7.215 7.215 0 0 1-5.415-2.019 7.85 7.85 0 0 1-1.979-5.74 6.538 6.538 0 0 1 2.659-5.756q2.664-1.85 8.028-2.045l4.146-.135v-1.073q0-3.724-3.72-3.726a16.669 16.669 0 0 0-6.734 1.775l-2.157-4.517a19.074 19.074 0 0 1 9.15-2.212q4.8 0 7.373 2.149t2.563 6.531v16.33Zm-1.923-11.355-2.522.088a7.9 7.9 0 0 0-4.232 1.051 3.344 3.344 0 0 0-1.39 2.935q0 2.834 3.167 2.831a4.956 4.956 0 0 0 3.623-1.337 4.767 4.767 0 0 0 1.355-3.554Z" fill="#86bc25"/><path data-name="Path 8" d="M189.542 34.54a7.688 7.688 0 0 1-6.612-3.351q-2.405-3.357-2.405-9.295 0-6.026 2.446-9.393a7.886 7.886 0 0 1 6.744-3.362 7.732 7.732 0 0 1 6.881 3.6h.213a28.3 28.3 0 0 1-.492-4.892V0h6.541v34.1h-5l-1.258-3.172h-.279a7.41 7.41 0 0 1-6.775 3.612m2.289-5.324a4.355 4.355 0 0 0 3.664-1.488q1.165-1.491 1.274-5.064v-.723q0-3.95-1.187-5.657a4.361 4.361 0 0 0-3.857-1.712 3.814 3.814 0 0 0-3.39 1.9 10.354 10.354 0 0 0-1.208 5.511 9.8 9.8 0 0 0 1.218 5.428 3.964 3.964 0 0 0 3.486 1.806" fill="#86bc25"/><path data-name="Path 9" d="M220.492 34.545q-5.77 0-9.018-3.268t-3.248-9.248q0-6.159 3-9.524a10.566 10.566 0 0 1 8.307-3.367q5.062 0 7.886 2.961t2.821 8.176v3.242h-15.412a6.53 6.53 0 0 0 1.644 4.45 5.708 5.708 0 0 0 4.318 1.6 17.508 17.508 0 0 0 4.085-.458 20.179 20.179 0 0 0 4.014-1.468v5.173a14.861 14.861 0 0 1-3.654 1.3 22.348 22.348 0 0 1-4.745.432m-.919-20.65a4.076 4.076 0 0 0-3.248 1.348 6.343 6.343 0 0 0-1.35 3.825h9.15a5.653 5.653 0 0 0-1.258-3.825 4.217 4.217 0 0 0-3.293-1.348" fill="#86bc25"/><path data-name="Path 10" d="M256.932 34.108h-6.521V19.8a7.357 7.357 0 0 0-.863-3.981 3.021 3.021 0 0 0-2.725-1.327 3.916 3.916 0 0 0-3.633 1.889q-1.134 1.881-1.132 6.2v11.527h-6.521V9.6h4.978l.878 3.133h.365a6.661 6.661 0 0 1 2.776-2.638 8.856 8.856 0 0 1 4.166-.952q5.366 0 7.267 3.591h.579a6.557 6.557 0 0 1 2.832-2.649 9.237 9.237 0 0 1 4.222-.942q4.065 0 6.145 2.134t2.086 6.854v15.977h-6.541V19.8a7.353 7.353 0 0 0-.868-3.981 3.01 3.01 0 0 0-2.725-1.327 4.038 4.038 0 0 0-3.578 1.754q-1.187 1.754-1.187 5.564Z" fill="#86bc25"/><path data-name="Path 11" d="M275.1 9.6h7.14l4.506 13.786a19.548 19.548 0 0 1 .792 4.252h.132a18.945 18.945 0 0 1 .918-4.252L293.013 9.6H300l-10.108 27.641a11.972 11.972 0 0 1-3.968 5.745 9.831 9.831 0 0 1-6.013 1.9 14.979 14.979 0 0 1-3.314-.369v-5.304a10.726 10.726 0 0 0 2.563.286 4.555 4.555 0 0 0 3.024-1.082 7.032 7.032 0 0 0 2.02-3.279l.386-1.207Z" fill="#86bc25"/><path data-name="Path 12" d="M5.567 57.027a4.4 4.4 0 0 1 3.659 1.65 7.4 7.4 0 0 1 1.3 4.673 7.418 7.418 0 0 1-1.314 4.694 4.393 4.393 0 0 1-3.649 1.676 5.122 5.122 0 0 1-2.136-.442 4.032 4.032 0 0 1-1.619-1.363H1.68L1.3 69.5H0V52.083h1.812v4.226c0 .952-.03 1.8-.086 2.555h.086a4.266 4.266 0 0 1 3.755-1.837M5.3 58.583a3.126 3.126 0 0 0-2.674 1.093 6.286 6.286 0 0 0-.817 3.674 6.289 6.289 0 0 0 .837 3.7 3.178 3.178 0 0 0 2.7 1.114 2.773 2.773 0 0 0 2.487-1.249 6.572 6.572 0 0 0 .817-3.586 6.3 6.3 0 0 0-.817-3.57A2.872 2.872 0 0 0 5.3 58.583" fill="#fff"/><path data-name="Path 13" d="M11.793 57.23h1.944l2.618 6.994a28.177 28.177 0 0 1 1.071 3.456h.086q.137-.57.594-1.952t2.964-8.5h1.938L17.873 71.2a7.02 7.02 0 0 1-1.786 2.935 3.731 3.731 0 0 1-2.5.869 7.239 7.239 0 0 1-1.639-.193v-1.49a6.238 6.238 0 0 0 1.345.135 2.775 2.775 0 0 0 2.659-2.149l.665-1.743Z" fill="#fff"/><path data-name="Path 14" d="M43.768 61.159a8.389 8.389 0 0 1-2.141 6.193 8.348 8.348 0 0 1-6.171 2.148h-4.42V53.134h4.887a7.71 7.71 0 0 1 5.785 2.118 8.1 8.1 0 0 1 2.06 5.907m-1.964.068a6.689 6.689 0 0 0-1.567-4.827 6.17 6.17 0 0 0-4.653-1.624h-2.695v13.075h2.258a6.747 6.747 0 0 0 4.988-1.676 6.723 6.723 0 0 0 1.67-4.949" fill="#fff"/><path data-name="Path 15" d="M52.106 69.719a5.428 5.428 0 0 1-4.187-1.655 6.532 6.532 0 0 1-1.533-4.6 7.225 7.225 0 0 1 1.426-4.71 4.673 4.673 0 0 1 3.821-1.749 4.455 4.455 0 0 1 3.557 1.514 5.919 5.919 0 0 1 1.309 4V63.7h-8.234a4.918 4.918 0 0 0 1.066 3.279 3.63 3.63 0 0 0 2.841 1.121 9.434 9.434 0 0 0 3.816-.827v1.655a8.944 8.944 0 0 1-1.817.609 9.786 9.786 0 0 1-2.065.187m-.492-11.158a2.936 2.936 0 0 0-2.3.963 4.546 4.546 0 0 0-1.01 2.665h6.257A4.159 4.159 0 0 0 53.8 59.5a2.654 2.654 0 0 0-2.182-.937" fill="#fff"/><path data-name="Rectangle 1" fill="#fff" d="M59.591 52.081h1.812v17.413h-1.812z"/><path data-name="Path 16" d="M75.561 63.35a6.871 6.871 0 0 1-1.472 4.684 5.125 5.125 0 0 1-4.07 1.686 5.274 5.274 0 0 1-2.847-.775 5.05 5.05 0 0 1-1.923-2.217 7.949 7.949 0 0 1-.675-3.377 6.882 6.882 0 0 1 1.461-4.673 5.113 5.113 0 0 1 4.06-1.671 4.986 4.986 0 0 1 3.989 1.712 6.848 6.848 0 0 1 1.477 4.632m-9.109 0a5.914 5.914 0 0 0 .919 3.58 3.141 3.141 0 0 0 2.695 1.233 3.173 3.173 0 0 0 2.7-1.228 5.91 5.91 0 0 0 .919-3.586 5.817 5.817 0 0 0-.919-3.554 3.213 3.213 0 0 0-2.725-1.213 3.164 3.164 0 0 0-2.684 1.2 5.869 5.869 0 0 0-.9 3.57" fill="#fff"/><path data-name="Path 17" d="M78.585 53.909a1.26 1.26 0 0 1 .3-.937 1.111 1.111 0 0 1 1.517.005 1.517 1.517 0 0 1 0 1.863 1.091 1.091 0 0 1-1.517 0 1.271 1.271 0 0 1-.3-.932M80.549 69.5h-1.811V57.23h1.812Z" fill="#fff"/><path data-name="Path 18" d="M88.252 68.184a6 6 0 0 0 .929-.073 5.7 5.7 0 0 0 .71-.151v1.421a3.181 3.181 0 0 1-.868.239 6.551 6.551 0 0 1-1.035.1q-3.463 0-3.466-3.752v-7.3h-1.715v-.9l1.715-.77.761-2.618h1.05v2.85H89.8v1.442h-3.466v7.218a2.511 2.511 0 0 0 .513 1.7 1.753 1.753 0 0 0 1.406.593" fill="#fff"/><path data-name="Path 19" d="M96.143 68.184a6 6 0 0 0 .929-.073 5.7 5.7 0 0 0 .71-.151v1.421a3.181 3.181 0 0 1-.868.239 6.551 6.551 0 0 1-1.035.1q-3.463 0-3.466-3.752v-7.3H90.7v-.9l1.715-.77.761-2.618h1.05v2.85h3.466v1.442h-3.467v7.218a2.511 2.511 0 0 0 .513 1.7 1.753 1.753 0 0 0 1.406.593" fill="#fff"/><path data-name="Path 20" d="M105.222 69.719a5.428 5.428 0 0 1-4.187-1.655 6.532 6.532 0 0 1-1.533-4.6 7.225 7.225 0 0 1 1.426-4.71 4.673 4.673 0 0 1 3.821-1.749 4.455 4.455 0 0 1 3.557 1.514 5.919 5.919 0 0 1 1.309 4V63.7h-8.235a4.918 4.918 0 0 0 1.066 3.279 3.63 3.63 0 0 0 2.842 1.119 9.434 9.434 0 0 0 3.816-.827v1.655a8.944 8.944 0 0 1-1.817.609 9.785 9.785 0 0 1-2.065.187m-.492-11.158a2.936 2.936 0 0 0-2.3.963 4.546 4.546 0 0 0-1.01 2.665h6.257a4.159 4.159 0 0 0-.766-2.691 2.654 2.654 0 0 0-2.182-.937" fill="#fff"/></g></g></g></svg>
                  </v-col>
                </v-row>
              </div>-->
              <div class="step-txt">
              <h2>Zastanawiasz się, jak pokierować swoją karierą? </h2>
              <p>
                Chcesz zdobyć nową wiedzę i postawić na swój rozwój? W
                takim razie nie może Cię zabraknąć w tegorocznej edycji CaseAcademy by Deloitte!
                Mamy dla Ciebie 5 ścieżek, w których możesz spróbować swoich sił:
                Audyt, Doradztwo Podatkowe, Doradztwo Finansowe,
                Zarządzanie Ryzykiem oraz Prawo.</p>
              <p>Wchodzisz w to?</p>
              <h2>Daj się poznać! Zrób krótki quiz i dowiedz się, do
                której CaseAcademy najbardziej pasujesz. </h2>
              <p>Pamiętaj o zaaplikowaniu do CaseAcademy, jak tylko wykonasz
                quiz. Na zwycięzców czeka nagroda finansowa <strong>5000 zł</strong>
                oraz skrócony proces rekrutacji do
                Deloitte! Na
                Twoje zgłoszenie czekamy do 3 listopada. Do zobaczenia!
              </p>
                <v-btn :x-large="true" :rounded="true"
                       elevation="0" class="start-btn" color="#80BD0A" @click="setNextStep(false)">
                  Przejdź do QUIZU
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content
            v-for="step in quizSteps" :step="step.step" :key="step.step"
            :class="'step-'+ step.step+ ' question-step'">
          <v-row >
            <v-col cols="12" md="5" class="img-col order-sm-2 order-md-1">
              <img :src="require(`@/assets/s${step.questionNo + 1}.png`)">
            </v-col>
            <v-col cols="12" md="7"
                   class="d-flex  flex-column order-sm-1 order-md-2">
<!--              <div class="header">
                <v-row>
                  <v-col cols="12" class="d-flex">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 75.002"><defs><clipPath id="a"><path data-name="Rectangle 2" transform="translate(0 -.002)" fill="none" d="M0 0h300v75.002H0z"/></clipPath></defs><g data-name="Vector Smart Object"><g data-name="Group 2"><g data-name="Group 1" clip-path="url(#a)" transform="translate(0 .002)"><path data-name="Path 1" d="M14.661 7.255a6.693 6.693 0 0 0-5.79 2.883q-2.055 2.88-2.055 8.035 0 10.718 7.845 10.715a24.291 24.291 0 0 0 7.972-1.688v5.7a21.614 21.614 0 0 1-8.591 1.644q-6.82 0-10.433-4.241T0 18.126a20.337 20.337 0 0 1 1.771-8.759 13.035 13.035 0 0 1 5.1-5.761 14.77 14.77 0 0 1 7.79-2.006 20.63 20.63 0 0 1 9.15 2.259l-2.137 5.524a35.421 35.421 0 0 0-3.527-1.494 10.366 10.366 0 0 0-3.486-.635" fill="#86bc25"/><path data-name="Path 2" d="m43.946 34.108-1.264-3.331h-.172a9.662 9.662 0 0 1-3.385 2.946 10.731 10.731 0 0 1-4.542.822 7.215 7.215 0 0 1-5.415-2.019 7.85 7.85 0 0 1-1.979-5.74 6.538 6.538 0 0 1 2.659-5.756q2.664-1.85 8.028-2.045l4.146-.135v-1.073q0-3.724-3.72-3.726a16.669 16.669 0 0 0-6.734 1.775l-2.157-4.517A19.074 19.074 0 0 1 38.562 9.1q4.8 0 7.373 2.149t2.565 6.528v16.33Zm-1.923-11.356-2.522.088a7.9 7.9 0 0 0-4.232 1.051 3.344 3.344 0 0 0-1.39 2.935q0 2.834 3.161 2.831a4.96 4.96 0 0 0 3.628-1.337 4.787 4.787 0 0 0 1.355-3.554Z" fill="#86bc25"/><path data-name="Path 3" d="M71.882 26.827a6.829 6.829 0 0 1-2.553 5.745q-2.558 1.967-7.642 1.972a23.5 23.5 0 0 1-4.445-.364 16.249 16.249 0 0 1-3.442-1.061v-5.527a22.043 22.043 0 0 0 4.09 1.473 16.391 16.391 0 0 0 4.009.588c2.365 0 3.547-.7 3.547-2.1a1.79 1.79 0 0 0-.467-1.28 6.714 6.714 0 0 0-1.629-1.119c-.766-.416-1.791-.906-3.075-1.457a19.352 19.352 0 0 1-4.05-2.191 6.172 6.172 0 0 1-1.883-2.316 7.823 7.823 0 0 1-.589-3.211 5.868 5.868 0 0 1 2.471-5.053q2.466-1.788 7-1.785a19.458 19.458 0 0 1 8.4 1.931l-1.964 4.819A34.9 34.9 0 0 0 66.3 14.6a10.233 10.233 0 0 0-3.187-.5q-2.885 0-2.882 1.6a1.888 1.888 0 0 0 .929 1.556 24.239 24.239 0 0 0 4.07 1.952 18.921 18.921 0 0 1 4.105 2.17 6.4 6.4 0 0 1 1.923 2.326 7.314 7.314 0 0 1 .619 3.133" fill="#86bc25"/><path data-name="Path 4" d="M87.781 34.545q-5.77 0-9.018-3.268t-3.248-9.248q0-6.159 3-9.524a10.566 10.566 0 0 1 8.307-3.367q5.062 0 7.886 2.961t2.821 8.176v3.242H82.117a6.53 6.53 0 0 0 1.644 4.45 5.708 5.708 0 0 0 4.318 1.6 17.508 17.508 0 0 0 4.085-.458 20.18 20.18 0 0 0 4.014-1.468v5.173a14.861 14.861 0 0 1-3.654 1.3 22.349 22.349 0 0 1-4.745.432m-.919-20.65a4.076 4.076 0 0 0-3.248 1.348 6.343 6.343 0 0 0-1.35 3.825h9.15a5.653 5.653 0 0 0-1.258-3.825 4.217 4.217 0 0 0-3.293-1.348" fill="#86bc25"/><path data-name="Path 5" d="m122.471 34.108-2.263-7.629h-11.393l-2.268 7.629h-7.135l11.027-32.177h8.1l11.071 32.177Zm-3.847-13.328q-3.144-10.367-3.537-11.725a35.349 35.349 0 0 1-.568-2.149q-.7 2.8-4.039 13.874Z" fill="#86bc25"/><path data-name="Path 6" d="M142.733 34.545q-11.159 0-11.159-12.558 0-6.253 3.035-9.55t8.7-3.3a16.191 16.191 0 0 1 7.434 1.671l-1.923 5.173q-1.538-.64-2.862-1.046a9.165 9.165 0 0 0-2.649-.4q-5.092 0-5.09 7.405 0 7.189 5.09 7.192a11.3 11.3 0 0 0 3.481-.515A12.37 12.37 0 0 0 150 27v5.719a10.326 10.326 0 0 1-3.2 1.426 17.383 17.383 0 0 1-4.07.4" fill="#86bc25"/><path data-name="Path 7" d="m170.71 34.108-1.258-3.331h-.173a9.674 9.674 0 0 1-3.39 2.946 10.731 10.731 0 0 1-4.542.822 7.215 7.215 0 0 1-5.415-2.019 7.85 7.85 0 0 1-1.979-5.74 6.538 6.538 0 0 1 2.659-5.756q2.664-1.85 8.028-2.045l4.146-.135v-1.073q0-3.724-3.72-3.726a16.669 16.669 0 0 0-6.734 1.775l-2.157-4.517a19.074 19.074 0 0 1 9.15-2.212q4.8 0 7.373 2.149t2.563 6.531v16.33Zm-1.923-11.355-2.522.088a7.9 7.9 0 0 0-4.232 1.051 3.344 3.344 0 0 0-1.39 2.935q0 2.834 3.167 2.831a4.956 4.956 0 0 0 3.623-1.337 4.767 4.767 0 0 0 1.355-3.554Z" fill="#86bc25"/><path data-name="Path 8" d="M189.542 34.54a7.688 7.688 0 0 1-6.612-3.351q-2.405-3.357-2.405-9.295 0-6.026 2.446-9.393a7.886 7.886 0 0 1 6.744-3.362 7.732 7.732 0 0 1 6.881 3.6h.213a28.3 28.3 0 0 1-.492-4.892V0h6.541v34.1h-5l-1.258-3.172h-.279a7.41 7.41 0 0 1-6.775 3.612m2.289-5.324a4.355 4.355 0 0 0 3.664-1.488q1.165-1.491 1.274-5.064v-.723q0-3.95-1.187-5.657a4.361 4.361 0 0 0-3.857-1.712 3.814 3.814 0 0 0-3.39 1.9 10.354 10.354 0 0 0-1.208 5.511 9.8 9.8 0 0 0 1.218 5.428 3.964 3.964 0 0 0 3.486 1.806" fill="#86bc25"/><path data-name="Path 9" d="M220.492 34.545q-5.77 0-9.018-3.268t-3.248-9.248q0-6.159 3-9.524a10.566 10.566 0 0 1 8.307-3.367q5.062 0 7.886 2.961t2.821 8.176v3.242h-15.412a6.53 6.53 0 0 0 1.644 4.45 5.708 5.708 0 0 0 4.318 1.6 17.508 17.508 0 0 0 4.085-.458 20.179 20.179 0 0 0 4.014-1.468v5.173a14.861 14.861 0 0 1-3.654 1.3 22.348 22.348 0 0 1-4.745.432m-.919-20.65a4.076 4.076 0 0 0-3.248 1.348 6.343 6.343 0 0 0-1.35 3.825h9.15a5.653 5.653 0 0 0-1.258-3.825 4.217 4.217 0 0 0-3.293-1.348" fill="#86bc25"/><path data-name="Path 10" d="M256.932 34.108h-6.521V19.8a7.357 7.357 0 0 0-.863-3.981 3.021 3.021 0 0 0-2.725-1.327 3.916 3.916 0 0 0-3.633 1.889q-1.134 1.881-1.132 6.2v11.527h-6.521V9.6h4.978l.878 3.133h.365a6.661 6.661 0 0 1 2.776-2.638 8.856 8.856 0 0 1 4.166-.952q5.366 0 7.267 3.591h.579a6.557 6.557 0 0 1 2.832-2.649 9.237 9.237 0 0 1 4.222-.942q4.065 0 6.145 2.134t2.086 6.854v15.977h-6.541V19.8a7.353 7.353 0 0 0-.868-3.981 3.01 3.01 0 0 0-2.725-1.327 4.038 4.038 0 0 0-3.578 1.754q-1.187 1.754-1.187 5.564Z" fill="#86bc25"/><path data-name="Path 11" d="M275.1 9.6h7.14l4.506 13.786a19.548 19.548 0 0 1 .792 4.252h.132a18.945 18.945 0 0 1 .918-4.252L293.013 9.6H300l-10.108 27.641a11.972 11.972 0 0 1-3.968 5.745 9.831 9.831 0 0 1-6.013 1.9 14.979 14.979 0 0 1-3.314-.369v-5.304a10.726 10.726 0 0 0 2.563.286 4.555 4.555 0 0 0 3.024-1.082 7.032 7.032 0 0 0 2.02-3.279l.386-1.207Z" fill="#86bc25"/><path data-name="Path 12" d="M5.567 57.027a4.4 4.4 0 0 1 3.659 1.65 7.4 7.4 0 0 1 1.3 4.673 7.418 7.418 0 0 1-1.314 4.694 4.393 4.393 0 0 1-3.649 1.676 5.122 5.122 0 0 1-2.136-.442 4.032 4.032 0 0 1-1.619-1.363H1.68L1.3 69.5H0V52.083h1.812v4.226c0 .952-.03 1.8-.086 2.555h.086a4.266 4.266 0 0 1 3.755-1.837M5.3 58.583a3.126 3.126 0 0 0-2.674 1.093 6.286 6.286 0 0 0-.817 3.674 6.289 6.289 0 0 0 .837 3.7 3.178 3.178 0 0 0 2.7 1.114 2.773 2.773 0 0 0 2.487-1.249 6.572 6.572 0 0 0 .817-3.586 6.3 6.3 0 0 0-.817-3.57A2.872 2.872 0 0 0 5.3 58.583" fill="#fff"/><path data-name="Path 13" d="M11.793 57.23h1.944l2.618 6.994a28.177 28.177 0 0 1 1.071 3.456h.086q.137-.57.594-1.952t2.964-8.5h1.938L17.873 71.2a7.02 7.02 0 0 1-1.786 2.935 3.731 3.731 0 0 1-2.5.869 7.239 7.239 0 0 1-1.639-.193v-1.49a6.238 6.238 0 0 0 1.345.135 2.775 2.775 0 0 0 2.659-2.149l.665-1.743Z" fill="#fff"/><path data-name="Path 14" d="M43.768 61.159a8.389 8.389 0 0 1-2.141 6.193 8.348 8.348 0 0 1-6.171 2.148h-4.42V53.134h4.887a7.71 7.71 0 0 1 5.785 2.118 8.1 8.1 0 0 1 2.06 5.907m-1.964.068a6.689 6.689 0 0 0-1.567-4.827 6.17 6.17 0 0 0-4.653-1.624h-2.695v13.075h2.258a6.747 6.747 0 0 0 4.988-1.676 6.723 6.723 0 0 0 1.67-4.949" fill="#fff"/><path data-name="Path 15" d="M52.106 69.719a5.428 5.428 0 0 1-4.187-1.655 6.532 6.532 0 0 1-1.533-4.6 7.225 7.225 0 0 1 1.426-4.71 4.673 4.673 0 0 1 3.821-1.749 4.455 4.455 0 0 1 3.557 1.514 5.919 5.919 0 0 1 1.309 4V63.7h-8.234a4.918 4.918 0 0 0 1.066 3.279 3.63 3.63 0 0 0 2.841 1.121 9.434 9.434 0 0 0 3.816-.827v1.655a8.944 8.944 0 0 1-1.817.609 9.786 9.786 0 0 1-2.065.187m-.492-11.158a2.936 2.936 0 0 0-2.3.963 4.546 4.546 0 0 0-1.01 2.665h6.257A4.159 4.159 0 0 0 53.8 59.5a2.654 2.654 0 0 0-2.182-.937" fill="#fff"/><path data-name="Rectangle 1" fill="#fff" d="M59.591 52.081h1.812v17.413h-1.812z"/><path data-name="Path 16" d="M75.561 63.35a6.871 6.871 0 0 1-1.472 4.684 5.125 5.125 0 0 1-4.07 1.686 5.274 5.274 0 0 1-2.847-.775 5.05 5.05 0 0 1-1.923-2.217 7.949 7.949 0 0 1-.675-3.377 6.882 6.882 0 0 1 1.461-4.673 5.113 5.113 0 0 1 4.06-1.671 4.986 4.986 0 0 1 3.989 1.712 6.848 6.848 0 0 1 1.477 4.632m-9.109 0a5.914 5.914 0 0 0 .919 3.58 3.141 3.141 0 0 0 2.695 1.233 3.173 3.173 0 0 0 2.7-1.228 5.91 5.91 0 0 0 .919-3.586 5.817 5.817 0 0 0-.919-3.554 3.213 3.213 0 0 0-2.725-1.213 3.164 3.164 0 0 0-2.684 1.2 5.869 5.869 0 0 0-.9 3.57" fill="#fff"/><path data-name="Path 17" d="M78.585 53.909a1.26 1.26 0 0 1 .3-.937 1.111 1.111 0 0 1 1.517.005 1.517 1.517 0 0 1 0 1.863 1.091 1.091 0 0 1-1.517 0 1.271 1.271 0 0 1-.3-.932M80.549 69.5h-1.811V57.23h1.812Z" fill="#fff"/><path data-name="Path 18" d="M88.252 68.184a6 6 0 0 0 .929-.073 5.7 5.7 0 0 0 .71-.151v1.421a3.181 3.181 0 0 1-.868.239 6.551 6.551 0 0 1-1.035.1q-3.463 0-3.466-3.752v-7.3h-1.715v-.9l1.715-.77.761-2.618h1.05v2.85H89.8v1.442h-3.466v7.218a2.511 2.511 0 0 0 .513 1.7 1.753 1.753 0 0 0 1.406.593" fill="#fff"/><path data-name="Path 19" d="M96.143 68.184a6 6 0 0 0 .929-.073 5.7 5.7 0 0 0 .71-.151v1.421a3.181 3.181 0 0 1-.868.239 6.551 6.551 0 0 1-1.035.1q-3.463 0-3.466-3.752v-7.3H90.7v-.9l1.715-.77.761-2.618h1.05v2.85h3.466v1.442h-3.467v7.218a2.511 2.511 0 0 0 .513 1.7 1.753 1.753 0 0 0 1.406.593" fill="#fff"/><path data-name="Path 20" d="M105.222 69.719a5.428 5.428 0 0 1-4.187-1.655 6.532 6.532 0 0 1-1.533-4.6 7.225 7.225 0 0 1 1.426-4.71 4.673 4.673 0 0 1 3.821-1.749 4.455 4.455 0 0 1 3.557 1.514 5.919 5.919 0 0 1 1.309 4V63.7h-8.235a4.918 4.918 0 0 0 1.066 3.279 3.63 3.63 0 0 0 2.842 1.119 9.434 9.434 0 0 0 3.816-.827v1.655a8.944 8.944 0 0 1-1.817.609 9.785 9.785 0 0 1-2.065.187m-.492-11.158a2.936 2.936 0 0 0-2.3.963 4.546 4.546 0 0 0-1.01 2.665h6.257a4.159 4.159 0 0 0-.766-2.691 2.654 2.654 0 0 0-2.182-.937" fill="#fff"/></g></g></g></svg>
                  </v-col>
                </v-row>
              </div>-->
              <div class="question-wrapper">
                <h2 class="question">{{ step.question }}</h2>
                <ul class="text-left answers">
                  <li v-for="(answer,answerIndex) in step.answers" :key="answer.label"
                      v-bind:class="{ selected: isSelected(step.step, answerIndex) }"
                      class="d-flex" @click="setNextStep(answer.cat, step.step, answerIndex)">
                    <div class="ico">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28"><defs><clipPath id="a"><path data-name="Rectangle 5" fill="none" d="M0 0h28v28H0z"/></clipPath></defs><g data-name="Vector Smart Object"><g data-name="Vector Smart Object"><g data-name="Group 6"><g data-name="Group 5" clip-path="url(#a)" fill="#00a89f"><path data-name="Path 41" d="M14 27.012A13.012 13.012 0 1 1 27.012 14 13.027 13.027 0 0 1 14 27.012M14 0a14 14 0 1 0 14 14A14 14 0 0 0 14 0"/><path data-name="Path 42" d="M11.236 7.627a.494.494 0 0 0-.687.71L16.4 14l-5.849 5.663a.494.494 0 0 0 .687.71l6.215-6.019a.493.493 0 0 0 0-.71Z"/></g></g></g><path data-name="Color Overlay" d="M0 14a14 14 0 1 1 14 14A14 14 0 0 1 0 14Zm.988 0A13.012 13.012 0 1 0 14 .988 13.027 13.027 0 0 0 .988 14Zm9.549 6.362a.494.494 0 0 1 .012-.7L16.4 14l-5.848-5.663a.494.494 0 0 1 .687-.71l6.215 6.018a.494.494 0 0 1 0 .71l-6.215 6.018a.494.494 0 0 1-.7-.012Z" fill="#80bd0a"/></g></svg>
                    </div>
                    <p>{{ answer.text }}</p>
                  </li>
                </ul>
                <div class="question-footer d-flex ">
                  <span class="prev-bt" @click="setPrevStep" v-if="step.step !== 1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 30"><defs><clipPath id="a"><path data-name="Rectangle 15" fill="none" d="M0 0h29v30H0z"/></clipPath></defs><g data-name="Vector Smart Object"><g data-name="Vector Smart Object"><g data-name="Group 26"><g data-name="Group 25" clip-path="url(#a)" fill="#00a89f"><path data-name="Path 61" d="M14.5 28.942A13.731 13.731 0 0 1 1.023 15 13.731 13.731 0 0 1 14.5 1.058 13.731 13.731 0 0 1 27.977 15 13.731 13.731 0 0 1 14.5 28.942M14.5 0A14.757 14.757 0 0 0 0 15a14.757 14.757 0 0 0 14.5 15A14.756 14.756 0 0 0 29 15 14.756 14.756 0 0 0 14.5 0"/><path data-name="Path 62" d="M21.194 14.868a.52.52 0 0 0-.512.529 6.3 6.3 0 0 1-6.182 6.396A6.3 6.3 0 0 1 8.318 15.4 6.3 6.3 0 0 1 14.5 9a6.047 6.047 0 0 1 3.7 1.276H16a.529.529 0 0 0 0 1.058h3.13a.52.52 0 0 0 .512-.529V7.678a.512.512 0 1 0-1.023 0v1.606a7.044 7.044 0 0 0-4.119-1.34A7.341 7.341 0 0 0 7.295 15.4a7.341 7.341 0 0 0 7.205 7.451 7.341 7.341 0 0 0 7.2-7.453.52.52 0 0 0-.512-.529"/></g></g></g><path data-name="Color Overlay" d="M0 15a14.508 14.508 0 1 1 14.5 15A14.757 14.757 0 0 1 0 15Zm1.023 0A13.484 13.484 0 1 0 14.5 1.059 13.73 13.73 0 0 0 1.023 15Zm6.271.4a7.342 7.342 0 0 1 7.205-7.454 7.049 7.049 0 0 1 4.118 1.341V7.68a.512.512 0 1 1 1.022 0v3.129a.52.52 0 0 1-.511.529H16a.53.53 0 0 1 0-1.058h2.2A6.05 6.05 0 0 0 14.5 9a6.4 6.4 0 1 0 6.182 6.4.512.512 0 1 1 1.023 0 7.21 7.21 0 1 1-14.411 0Z" fill="#80bd0a"/></g></svg> Wróć
                  </span>
                </div>

              </div>
            </v-col>
          </v-row>
        </v-stepper-content>
        <v-stepper-content step="12" :class="'step-'+ stepsLength + ' quiz-end'">
          <v-row >
            <v-col cols="12" md="5" class="img-col order-sm-2 order-md-1">
              <img :src="require(`@/assets/${quizResult.image}`)">
            </v-col>
            <v-col cols="12" md="7" class="d-flex flex-column order-sm-1 order-md-2"
                   :class="quizResult.caseAcademy === null ? 'justify-center' : ''">
<!--              <div class="header">
                <v-row>
                  <v-col cols="12" class="d-flex">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 75.002"><defs><clipPath id="a"><path data-name="Rectangle 2" transform="translate(0 -.002)" fill="none" d="M0 0h300v75.002H0z"/></clipPath></defs><g data-name="Vector Smart Object"><g data-name="Group 2"><g data-name="Group 1" clip-path="url(#a)" transform="translate(0 .002)"><path data-name="Path 1" d="M14.661 7.255a6.693 6.693 0 0 0-5.79 2.883q-2.055 2.88-2.055 8.035 0 10.718 7.845 10.715a24.291 24.291 0 0 0 7.972-1.688v5.7a21.614 21.614 0 0 1-8.591 1.644q-6.82 0-10.433-4.241T0 18.126a20.337 20.337 0 0 1 1.771-8.759 13.035 13.035 0 0 1 5.1-5.761 14.77 14.77 0 0 1 7.79-2.006 20.63 20.63 0 0 1 9.15 2.259l-2.137 5.524a35.421 35.421 0 0 0-3.527-1.494 10.366 10.366 0 0 0-3.486-.635" fill="#86bc25"/><path data-name="Path 2" d="m43.946 34.108-1.264-3.331h-.172a9.662 9.662 0 0 1-3.385 2.946 10.731 10.731 0 0 1-4.542.822 7.215 7.215 0 0 1-5.415-2.019 7.85 7.85 0 0 1-1.979-5.74 6.538 6.538 0 0 1 2.659-5.756q2.664-1.85 8.028-2.045l4.146-.135v-1.073q0-3.724-3.72-3.726a16.669 16.669 0 0 0-6.734 1.775l-2.157-4.517A19.074 19.074 0 0 1 38.562 9.1q4.8 0 7.373 2.149t2.565 6.528v16.33Zm-1.923-11.356-2.522.088a7.9 7.9 0 0 0-4.232 1.051 3.344 3.344 0 0 0-1.39 2.935q0 2.834 3.161 2.831a4.96 4.96 0 0 0 3.628-1.337 4.787 4.787 0 0 0 1.355-3.554Z" fill="#86bc25"/><path data-name="Path 3" d="M71.882 26.827a6.829 6.829 0 0 1-2.553 5.745q-2.558 1.967-7.642 1.972a23.5 23.5 0 0 1-4.445-.364 16.249 16.249 0 0 1-3.442-1.061v-5.527a22.043 22.043 0 0 0 4.09 1.473 16.391 16.391 0 0 0 4.009.588c2.365 0 3.547-.7 3.547-2.1a1.79 1.79 0 0 0-.467-1.28 6.714 6.714 0 0 0-1.629-1.119c-.766-.416-1.791-.906-3.075-1.457a19.352 19.352 0 0 1-4.05-2.191 6.172 6.172 0 0 1-1.883-2.316 7.823 7.823 0 0 1-.589-3.211 5.868 5.868 0 0 1 2.471-5.053q2.466-1.788 7-1.785a19.458 19.458 0 0 1 8.4 1.931l-1.964 4.819A34.9 34.9 0 0 0 66.3 14.6a10.233 10.233 0 0 0-3.187-.5q-2.885 0-2.882 1.6a1.888 1.888 0 0 0 .929 1.556 24.239 24.239 0 0 0 4.07 1.952 18.921 18.921 0 0 1 4.105 2.17 6.4 6.4 0 0 1 1.923 2.326 7.314 7.314 0 0 1 .619 3.133" fill="#86bc25"/><path data-name="Path 4" d="M87.781 34.545q-5.77 0-9.018-3.268t-3.248-9.248q0-6.159 3-9.524a10.566 10.566 0 0 1 8.307-3.367q5.062 0 7.886 2.961t2.821 8.176v3.242H82.117a6.53 6.53 0 0 0 1.644 4.45 5.708 5.708 0 0 0 4.318 1.6 17.508 17.508 0 0 0 4.085-.458 20.18 20.18 0 0 0 4.014-1.468v5.173a14.861 14.861 0 0 1-3.654 1.3 22.349 22.349 0 0 1-4.745.432m-.919-20.65a4.076 4.076 0 0 0-3.248 1.348 6.343 6.343 0 0 0-1.35 3.825h9.15a5.653 5.653 0 0 0-1.258-3.825 4.217 4.217 0 0 0-3.293-1.348" fill="#86bc25"/><path data-name="Path 5" d="m122.471 34.108-2.263-7.629h-11.393l-2.268 7.629h-7.135l11.027-32.177h8.1l11.071 32.177Zm-3.847-13.328q-3.144-10.367-3.537-11.725a35.349 35.349 0 0 1-.568-2.149q-.7 2.8-4.039 13.874Z" fill="#86bc25"/><path data-name="Path 6" d="M142.733 34.545q-11.159 0-11.159-12.558 0-6.253 3.035-9.55t8.7-3.3a16.191 16.191 0 0 1 7.434 1.671l-1.923 5.173q-1.538-.64-2.862-1.046a9.165 9.165 0 0 0-2.649-.4q-5.092 0-5.09 7.405 0 7.189 5.09 7.192a11.3 11.3 0 0 0 3.481-.515A12.37 12.37 0 0 0 150 27v5.719a10.326 10.326 0 0 1-3.2 1.426 17.383 17.383 0 0 1-4.07.4" fill="#86bc25"/><path data-name="Path 7" d="m170.71 34.108-1.258-3.331h-.173a9.674 9.674 0 0 1-3.39 2.946 10.731 10.731 0 0 1-4.542.822 7.215 7.215 0 0 1-5.415-2.019 7.85 7.85 0 0 1-1.979-5.74 6.538 6.538 0 0 1 2.659-5.756q2.664-1.85 8.028-2.045l4.146-.135v-1.073q0-3.724-3.72-3.726a16.669 16.669 0 0 0-6.734 1.775l-2.157-4.517a19.074 19.074 0 0 1 9.15-2.212q4.8 0 7.373 2.149t2.563 6.531v16.33Zm-1.923-11.355-2.522.088a7.9 7.9 0 0 0-4.232 1.051 3.344 3.344 0 0 0-1.39 2.935q0 2.834 3.167 2.831a4.956 4.956 0 0 0 3.623-1.337 4.767 4.767 0 0 0 1.355-3.554Z" fill="#86bc25"/><path data-name="Path 8" d="M189.542 34.54a7.688 7.688 0 0 1-6.612-3.351q-2.405-3.357-2.405-9.295 0-6.026 2.446-9.393a7.886 7.886 0 0 1 6.744-3.362 7.732 7.732 0 0 1 6.881 3.6h.213a28.3 28.3 0 0 1-.492-4.892V0h6.541v34.1h-5l-1.258-3.172h-.279a7.41 7.41 0 0 1-6.775 3.612m2.289-5.324a4.355 4.355 0 0 0 3.664-1.488q1.165-1.491 1.274-5.064v-.723q0-3.95-1.187-5.657a4.361 4.361 0 0 0-3.857-1.712 3.814 3.814 0 0 0-3.39 1.9 10.354 10.354 0 0 0-1.208 5.511 9.8 9.8 0 0 0 1.218 5.428 3.964 3.964 0 0 0 3.486 1.806" fill="#86bc25"/><path data-name="Path 9" d="M220.492 34.545q-5.77 0-9.018-3.268t-3.248-9.248q0-6.159 3-9.524a10.566 10.566 0 0 1 8.307-3.367q5.062 0 7.886 2.961t2.821 8.176v3.242h-15.412a6.53 6.53 0 0 0 1.644 4.45 5.708 5.708 0 0 0 4.318 1.6 17.508 17.508 0 0 0 4.085-.458 20.179 20.179 0 0 0 4.014-1.468v5.173a14.861 14.861 0 0 1-3.654 1.3 22.348 22.348 0 0 1-4.745.432m-.919-20.65a4.076 4.076 0 0 0-3.248 1.348 6.343 6.343 0 0 0-1.35 3.825h9.15a5.653 5.653 0 0 0-1.258-3.825 4.217 4.217 0 0 0-3.293-1.348" fill="#86bc25"/><path data-name="Path 10" d="M256.932 34.108h-6.521V19.8a7.357 7.357 0 0 0-.863-3.981 3.021 3.021 0 0 0-2.725-1.327 3.916 3.916 0 0 0-3.633 1.889q-1.134 1.881-1.132 6.2v11.527h-6.521V9.6h4.978l.878 3.133h.365a6.661 6.661 0 0 1 2.776-2.638 8.856 8.856 0 0 1 4.166-.952q5.366 0 7.267 3.591h.579a6.557 6.557 0 0 1 2.832-2.649 9.237 9.237 0 0 1 4.222-.942q4.065 0 6.145 2.134t2.086 6.854v15.977h-6.541V19.8a7.353 7.353 0 0 0-.868-3.981 3.01 3.01 0 0 0-2.725-1.327 4.038 4.038 0 0 0-3.578 1.754q-1.187 1.754-1.187 5.564Z" fill="#86bc25"/><path data-name="Path 11" d="M275.1 9.6h7.14l4.506 13.786a19.548 19.548 0 0 1 .792 4.252h.132a18.945 18.945 0 0 1 .918-4.252L293.013 9.6H300l-10.108 27.641a11.972 11.972 0 0 1-3.968 5.745 9.831 9.831 0 0 1-6.013 1.9 14.979 14.979 0 0 1-3.314-.369v-5.304a10.726 10.726 0 0 0 2.563.286 4.555 4.555 0 0 0 3.024-1.082 7.032 7.032 0 0 0 2.02-3.279l.386-1.207Z" fill="#86bc25"/><path data-name="Path 12" d="M5.567 57.027a4.4 4.4 0 0 1 3.659 1.65 7.4 7.4 0 0 1 1.3 4.673 7.418 7.418 0 0 1-1.314 4.694 4.393 4.393 0 0 1-3.649 1.676 5.122 5.122 0 0 1-2.136-.442 4.032 4.032 0 0 1-1.619-1.363H1.68L1.3 69.5H0V52.083h1.812v4.226c0 .952-.03 1.8-.086 2.555h.086a4.266 4.266 0 0 1 3.755-1.837M5.3 58.583a3.126 3.126 0 0 0-2.674 1.093 6.286 6.286 0 0 0-.817 3.674 6.289 6.289 0 0 0 .837 3.7 3.178 3.178 0 0 0 2.7 1.114 2.773 2.773 0 0 0 2.487-1.249 6.572 6.572 0 0 0 .817-3.586 6.3 6.3 0 0 0-.817-3.57A2.872 2.872 0 0 0 5.3 58.583" fill="#fff"/><path data-name="Path 13" d="M11.793 57.23h1.944l2.618 6.994a28.177 28.177 0 0 1 1.071 3.456h.086q.137-.57.594-1.952t2.964-8.5h1.938L17.873 71.2a7.02 7.02 0 0 1-1.786 2.935 3.731 3.731 0 0 1-2.5.869 7.239 7.239 0 0 1-1.639-.193v-1.49a6.238 6.238 0 0 0 1.345.135 2.775 2.775 0 0 0 2.659-2.149l.665-1.743Z" fill="#fff"/><path data-name="Path 14" d="M43.768 61.159a8.389 8.389 0 0 1-2.141 6.193 8.348 8.348 0 0 1-6.171 2.148h-4.42V53.134h4.887a7.71 7.71 0 0 1 5.785 2.118 8.1 8.1 0 0 1 2.06 5.907m-1.964.068a6.689 6.689 0 0 0-1.567-4.827 6.17 6.17 0 0 0-4.653-1.624h-2.695v13.075h2.258a6.747 6.747 0 0 0 4.988-1.676 6.723 6.723 0 0 0 1.67-4.949" fill="#fff"/><path data-name="Path 15" d="M52.106 69.719a5.428 5.428 0 0 1-4.187-1.655 6.532 6.532 0 0 1-1.533-4.6 7.225 7.225 0 0 1 1.426-4.71 4.673 4.673 0 0 1 3.821-1.749 4.455 4.455 0 0 1 3.557 1.514 5.919 5.919 0 0 1 1.309 4V63.7h-8.234a4.918 4.918 0 0 0 1.066 3.279 3.63 3.63 0 0 0 2.841 1.121 9.434 9.434 0 0 0 3.816-.827v1.655a8.944 8.944 0 0 1-1.817.609 9.786 9.786 0 0 1-2.065.187m-.492-11.158a2.936 2.936 0 0 0-2.3.963 4.546 4.546 0 0 0-1.01 2.665h6.257A4.159 4.159 0 0 0 53.8 59.5a2.654 2.654 0 0 0-2.182-.937" fill="#fff"/><path data-name="Rectangle 1" fill="#fff" d="M59.591 52.081h1.812v17.413h-1.812z"/><path data-name="Path 16" d="M75.561 63.35a6.871 6.871 0 0 1-1.472 4.684 5.125 5.125 0 0 1-4.07 1.686 5.274 5.274 0 0 1-2.847-.775 5.05 5.05 0 0 1-1.923-2.217 7.949 7.949 0 0 1-.675-3.377 6.882 6.882 0 0 1 1.461-4.673 5.113 5.113 0 0 1 4.06-1.671 4.986 4.986 0 0 1 3.989 1.712 6.848 6.848 0 0 1 1.477 4.632m-9.109 0a5.914 5.914 0 0 0 .919 3.58 3.141 3.141 0 0 0 2.695 1.233 3.173 3.173 0 0 0 2.7-1.228 5.91 5.91 0 0 0 .919-3.586 5.817 5.817 0 0 0-.919-3.554 3.213 3.213 0 0 0-2.725-1.213 3.164 3.164 0 0 0-2.684 1.2 5.869 5.869 0 0 0-.9 3.57" fill="#fff"/><path data-name="Path 17" d="M78.585 53.909a1.26 1.26 0 0 1 .3-.937 1.111 1.111 0 0 1 1.517.005 1.517 1.517 0 0 1 0 1.863 1.091 1.091 0 0 1-1.517 0 1.271 1.271 0 0 1-.3-.932M80.549 69.5h-1.811V57.23h1.812Z" fill="#fff"/><path data-name="Path 18" d="M88.252 68.184a6 6 0 0 0 .929-.073 5.7 5.7 0 0 0 .71-.151v1.421a3.181 3.181 0 0 1-.868.239 6.551 6.551 0 0 1-1.035.1q-3.463 0-3.466-3.752v-7.3h-1.715v-.9l1.715-.77.761-2.618h1.05v2.85H89.8v1.442h-3.466v7.218a2.511 2.511 0 0 0 .513 1.7 1.753 1.753 0 0 0 1.406.593" fill="#fff"/><path data-name="Path 19" d="M96.143 68.184a6 6 0 0 0 .929-.073 5.7 5.7 0 0 0 .71-.151v1.421a3.181 3.181 0 0 1-.868.239 6.551 6.551 0 0 1-1.035.1q-3.463 0-3.466-3.752v-7.3H90.7v-.9l1.715-.77.761-2.618h1.05v2.85h3.466v1.442h-3.467v7.218a2.511 2.511 0 0 0 .513 1.7 1.753 1.753 0 0 0 1.406.593" fill="#fff"/><path data-name="Path 20" d="M105.222 69.719a5.428 5.428 0 0 1-4.187-1.655 6.532 6.532 0 0 1-1.533-4.6 7.225 7.225 0 0 1 1.426-4.71 4.673 4.673 0 0 1 3.821-1.749 4.455 4.455 0 0 1 3.557 1.514 5.919 5.919 0 0 1 1.309 4V63.7h-8.235a4.918 4.918 0 0 0 1.066 3.279 3.63 3.63 0 0 0 2.842 1.119 9.434 9.434 0 0 0 3.816-.827v1.655a8.944 8.944 0 0 1-1.817.609 9.785 9.785 0 0 1-2.065.187m-.492-11.158a2.936 2.936 0 0 0-2.3.963 4.546 4.546 0 0 0-1.01 2.665h6.257a4.159 4.159 0 0 0-.766-2.691 2.654 2.654 0 0 0-2.182-.937" fill="#fff"/></g></g></g></svg>
                  </v-col>
                </v-row>
              </div>-->
              <div class="question-wrapper" v-if="quizResult.caseAcademy">
                <h2 >
                  Twoja CaseAcademy to<br>
                  {{ quizResult.caseAcademy }} Academy
                </h2>
                <p>
                  {{ quizResult.text1 }}
                </p>
                <p>
                  {{ quizResult.text2 }}
                </p>
                <p><strong>Czekają na Ciebie:</strong></p>
                <ul>
                  <li>cykl spotkań w formie symulacji biznesowych</li>
                  <li>praktyczna wiedza i bezkonkurencyjne doświadczenie,
                    które pozwolą wcielić Ci się w rolę konsultanta i odtworzyć pracę z klientem
                  </li>
                  <li>cykl spotkań w formie symulacji biznesowych</li>
                  <li>networking z ekspertami Deloitte</li>
                  <li>poznanie zespołów Deloitte, specyfiki ich zadań i klientów</li>
                  <li>certyfikat udziału, czyli cenny wpis w CV</li>
                  <li>pakiet warsztatów dopełniających Twoją wiedzę z kompetencji miękkich
                    (personal branding, wizualizacja danych czy przygotowanie do rekrutacji)
                  </li>
                  <li>skrócony proces rekrutacji do Deloitte</li>
                  <li>nagroda dla zwycięzców – 5000 zł</li>

                </ul>
                <v-btn :x-large="true" :rounded="true"
                       :href="quizResult.link"
                       target="_blank"
                       elevation="0" class="join-btn" color="#85BB24"
                       @click="startOver($event,quizResult.link)">
                  Aplikuj
                </v-btn>
              </div>
              <div class="question-wrapper question-wrapper-center"
                   v-if="quizResult.caseAcademy === null">
                <h2 >
                  {{ quizResult.text1 }}
                </h2>
                <p>
                  {{ quizResult.text2 }}
                </p>

                <v-btn :x-large="true" :rounded="true"
                       elevation="0" class="join-btn" color="#85BB24" @click="startOver($event)">
                  Przejdź do QUIZU
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-app>
</template>

<script>
export default {
  name: 'Quiz',
  data() {
    return {
      e1: 1,
      results: [
        {
          caseAcademy: 'Audit',
          text1: 'Wygląda na to, że jesteś przyszłym/przyszłą #AuditMaster! Lubisz konkrety, jesteś wnikliwy/a i chcesz się rozwijać.',
          text2: 'W trakcie Audit Academy organizowanej przez Deloitte poznasz tajniki pracy audytora. Dowiesz się, jak wyglądają etapy badania sprawozdań finansowych i zmierzysz się z realnymi wyzwaniami pracy dla klienta.',
          image: 'rn1.png',
          link: 'https://apply.deloittece.com/pl_PL/careers/Jobdetail?jobId=6695',
        },
        {
          caseAcademy: 'Law',
          text1: 'Bez dwóch zdań jesteś #LegalHero! Umiesz pracować w zespole i masz głowę otwartą na nowe rozwiązania. Jesteś ambitny/a i lubisz zdobywać wiedzę. ',
          text2: 'Poznaj specyfikę pracy prawników z kancelarii Deloitte Legal i zainwestuj w swoją karierę. Zobacz, jak wygląda praca w międzynarodowej kancelarii w praktyce i naucz się szerokiego, zróżnicowanego spojrzenia na biznes i na naszych międzynarodowych klientów.',
          image: 'rn2.png',
          link: 'https://apply.deloittece.com/pl_PL/careers/Jobdetail?jobId=6692',
        },
        {
          caseAcademy: 'Tax',
          text1: '#TaxLover to Ty! Jesteś dynamiczny/a i nie ma dla Ciebie rzeczy niemożliwych. Orientujesz się realiach dzisiejszego rynku i trzymasz rękę na pulsie.',
          text2: 'Zobacz, jak wygląda praca doradcy podatkowego w praktyce! Spójrz na tę złożoną dziedzinę okiem doświadczonego eksperta, uczestnicząc w symulacjach biznesowych.',
          image: 'rn3.png',
          link: 'https://apply.deloittece.com/pl_PL/careers/Jobdetail?jobId=6690',
        },
        {
          caseAcademy: 'Dealmaker',
          text1: 'Twoje drugie imię to #DealMaker! Szukasz wyzwań, interesujesz się ekonomią i chcesz związać swoją karierę z biznesem.',
          text2: 'W CaseAcademy by Deloitte zobaczysz, jak wygląda praca doradcy inwestycyjnego podczas symulacji biznesowej. Poznasz szczegółowo proces fuzji i przejęć oraz pogłębisz wiedzę z zakresu krajowych i międzynarodowych projektów Deloitte.',
          image: 'rn4.png',
          link: 'https://apply.deloittece.com/careers/Jobdetail?jobId=6694',
        },
        {
          caseAcademy: 'Risk Advisory',
          text1: 'Tobie nigdy nic nie umknie – jesteś prawdziwym/ą #RiskBuster! Jako doskonały strateg lubisz dużo analizować i zawsze bierzesz pod uwagę wszystkie za i przeciw. Poszukujesz innowacji i nowych dróg rozwoju. ',
          text2: 'Dowiedz się, jak umiejętne zarządzanie ryzykiem oraz innowacyjne rozwiązania poprawiają wyniki firmy i zainwestuj w swoją karierę. Spójrz na zarządzanie ryzykiem okiem doświadczonego eksperta i poszerz swoją wiedzę dzięki symulacjom biznesowym z naszymi najlepszymi specjalistami.',
          image: 'rn5.png',
          link: 'https://apply.deloittece.com/pl_PL/careers/Jobdetail?jobId=6689',
        },
        {
          caseAcademy: null,
          text1: 'Wygląda na to, że pasujesz do więcej niż jednej CaseAcademy!',
          text2: 'To nic, ponieważ możesz wziąć udział w więcej niż jednej ścieżce i sprawdzić, co najbardziej Cię interesuje. Jeśli jednak chcesz uzyskać konkretny wynik – wypełnij quiz jeszcze raz.',
          image: 'rn6.png',
          link: '',
        },
      ],
      answers: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
      selected: [],
      quizSteps: [
        {
          step: 2,
          questionNo: 1,
          question: 'Rano, przed wyjściem z domu na uczelnię:',
          answers: [
            {
              label: 'a',
              cat: 5,
              selected: false,
              text: 'zaczynam dzień od kawy',
            },
            {
              label: 'b',
              cat: 4,
              selected: false,
              text: 'nie wyobrażam sobie rozpoczęcia dnia bez ćwiczeń',
            },
            {
              label: 'c',
              cat: 2,
              selected: false,
              text: 'przygotowuję śniadanie mistrza',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'planuję swój dzień',
            },
            {
              label: 'c',
              cat: 1,
              selected: false,
              text: 'sprawdzam maile i konto bankowe',
            },
          ],
        },
        {
          step: 3,
          questionNo: 2,
          question: 'W czym odnalazłbyś/odnalazłabyś się najlepiej?',
          answers: [
            {
              label: 'a',
              cat: 5,
              selected: false,
              text: 'analizy i prognozy to mój żywioł',
            },
            {
              label: 'b',
              cat: 3,
              selected: false,
              text: 'PIT, CIT i VAT to moje nick names',
            },
            {
              label: 'c',
              cat: 4,
              selected: false,
              text: 'bez transakcji na rynkach globalnych dzień będzie stracony',
            },
            {
              label: 'c',
              cat: 1,
              selected: false,
              text: 'chcę wiedzieć jak przepływa pieniądz ',
            },
            {
              label: 'c',
              cat: 2,
              selected: false,
              text: 'lubię wygrywać, zwłaszcza w sporach',
            },
          ],
        },
        {
          step: 4,
          questionNo: 3,
          question: 'Tworzenie swojego biznesu zaczynam od:',
          answers: [
            {
              label: 'a',
              cat: 5,
              selected: false,
              text: 'rozważenia za i przeciw',
            },
            {
              label: 'b',
              cat: 1,
              selected: false,
              text: 'biznes planu',
            },
            {
              label: 'b',
              cat: 4,
              selected: false,
              text: 'poszukiwania inwestorów',
            },
            {
              label: 'c',
              cat: 2,
              selected: false,
              text: 'tworzenia zespołu',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'założenia NIP i REGON',
            },
          ],
        },
        {
          step: 5,
          questionNo: 4,
          question: 'Która cecha charakteru opisuje Cię najlepiej?',
          answers: [
            {
              label: 'a',
              cat: 2,
              selected: false,
              text: 'ambitny/-a',
            },
            {
              label: 'b',
              cat: 3,
              selected: false,
              text: 'dynamiczny/-a',
            },
            {
              label: 'c',
              cat: 5,
              selected: false,
              text: 'innowacyjny/-a',
            },
            {
              label: 'c',
              cat: 1,
              selected: false,
              text: 'wnikliwy/-a',
            },
            {
              label: 'c',
              cat: 4,
              selected: false,
              text: 'logiczny/-a',
            },
          ],
        },
        {
          step: 6,
          questionNo: 5,
          question: 'Skąd czerpiesz wiedzę?',
          answers: [
            {
              label: 'a',
              cat: 2,
              selected: false,
              text: 'książki',
            },
            {
              label: 'b',
              cat: 5,
              selected: false,
              text: 'podcasty/YT',
            },
            {
              label: 'c',
              cat: 1,
              selected: false,
              text: 'szkolenia',
            },
            {
              label: 'c',
              cat: 4,
              selected: false,
              text: 'prasa branżowa',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'blogi online',
            },
          ],
        },
        {
          step: 7,
          questionNo: 6,
          question: 'W moim przyszłym miejscu pracy szukam:',
          answers: [
            {
              label: 'a',
              cat: 4,
              selected: false,
              text: 'ciekawych wyzwań',
            },
            {
              label: 'b',
              cat: 2,
              selected: false,
              text: 'inspirujących ekspertów',
            },
            {
              label: 'c',
              cat: 1,
              selected: false,
              text: 'szerokiego rozwoju',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'dobrej atmosfery',
            },
            {
              label: 'c',
              cat: 5,
              selected: false,
              text: 'innowacyjnych projektów',
            },
          ],
        },
        {
          step: 8,
          questionNo: 7,
          question: 'Twoje życiowe motto to:',
          answers: [
            {
              label: 'a',
              cat: 5,
              selected: false,
              text: 'No risk, no fun',
            },
            {
              label: 'b',
              cat: 2,
              selected: false,
              text: 'Dura lex sed lex',
            },
            {
              label: 'c',
              cat: 4,
              selected: false,
              text: 'Czas to pieniądz',
            },
            {
              label: 'c',
              cat: 1,
              selected: false,
              text: 'Ziarnko do ziarnka, a zbierze się miarka',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'Nie ma rzeczy niemożliwych',
            },
          ],
        },
        {
          step: 9,
          questionNo: 8,
          question: 'Serial/film, który wybrałabyś/wybrałbyś na sobotni wieczór to:',
          answers: [
            {
              label: 'a',
              cat: 2,
              selected: false,
              text: 'Suits',
            },
            {
              label: 'b',
              cat: 3,
              selected: false,
              text: 'Wilk z Wall Street',
            },
            {
              label: 'c',
              cat: 4,
              selected: false,
              text: 'Big Short',
            },
            {
              label: 'c',
              cat: 1,
              selected: false,
              text: 'The Accountant',
            },
            {
              label: 'c',
              cat: 5,
              selected: false,
              text: 'Mission Impossible',
            },
          ],
        },
        {
          step: 10,
          questionNo: 9,
          question: 'Twoja ulubiona pizza to:',
          answers: [
            {
              label: 'a',
              cat: 1,
              selected: false,
              text: 'margherita',
            },
            {
              label: 'b',
              cat: 2,
              selected: false,
              text: 'prosciutto i rukola',
            },
            {
              label: 'c',
              cat: 4,
              selected: false,
              text: '4 sery',
            },
            {
              label: 'c',
              cat: 5,
              selected: false,
              text: 'hawajska',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'pepperoni',
            },
          ],
        },
        {
          step: 11,
          questionNo: 10,
          question: 'Który sport lubisz najbardziej?',
          answers: [
            {
              label: 'a',
              cat: 2,
              selected: false,
              text: 'tenis',
            },
            {
              label: 'b',
              cat: 4,
              selected: false,
              text: 'golf',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'jazda na rowerze',
            },
            {
              label: 'c',
              cat: 5,
              selected: false,
              text: 'sporty ekstremalne',
            },
            {
              label: 'c',
              cat: 1,
              selected: false,
              text: 'bieganie',
            },
          ],
        },
      ],
    };
  },
  methods: {
    setNextStep(answerCat = false, step = false, answerIndex = false) {
      if (answerCat) {
        const stepFilled = this.selected.findIndex((selected) => selected.step === step);
        if (stepFilled > -1) {
          this.answers[this.selected[stepFilled].cat] -= 1;
          this.selected.splice(stepFilled, 1);
        }

        this.selected.push({
          step,
          answer: answerIndex,
          cat: answerCat,
        });
        this.answers[answerCat] += 1;
      }
      this.e1 += 1;
    },
    isSelected(step, answer) {
      const isSelected = this.selected.find((selected) => {
        if (selected.step === step && selected.answer === answer) {
          return true;
        }
        return false;
      });

      return isSelected;
    },
    setPrevStep() {
      this.e1 -= 1;
    },
    startOver(event, url = null) {
      event.preventDefault();
      if (url !== null) {
        window.open(url, '_blank').focus();
      }
      this.e1 = 1;
      this.selected = [];
      this.answers[1] = 0;
      this.answers[2] = 0;
      this.answers[3] = 0;
      this.answers[4] = 0;
      this.answers[5] = 0;
    },
  },
  computed: {
    stepsLength() {
      return (this.quizSteps.length + 2);
    },
    quizResult() {
      const { answers } = this;
      const hasDuplicates = (arr) => arr.length !== new Set(arr).size;
      const isResultDuplicate = (resultNo) => {
        const duplicates = [];
        const resultValue = answers[resultNo];
        // eslint-disable-next-line consistent-return
        Object.values(answers).forEach((value, key) => {
          if (resultValue === value) {
            duplicates.push((key + 1));
          }
        });

        if (duplicates.length && duplicates.length >= 2
            // eslint-disable-next-line radix
            && duplicates.includes(parseInt(resultNo))) {
          return true;
        }

        return false;
      };

      const valueKeys = Object.keys(answers);
      const values = [];
      valueKeys.forEach((key) => {
        values.push(answers[key]);
      });

      const resultNo = Object.keys(answers).reduce((a, b) => (answers[a] > answers[b] ? a : b));

      if (this.$gtm.enabled() && this.e1 === this.stepsLength) {
        // eslint-disable-next-line no-console
        // console.log(this.e1);
        // console.log('gtm');
        // eslint-disable-next-line no-unused-expressions
        window.dataLayer?.push({
          event: 'code-academy-quiz-finished',
        });
      }

      if (hasDuplicates(values) && isResultDuplicate(resultNo)) {
        return this.results[(this.results.length - 1)];
      }
      return this.results[(resultNo - 1)];
    },
  },
};
</script>

<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap');

@media screen and (max-width: 959px) {
  .order-sm-1 {
    order: 1!important;
  }

  .order-sm-2 {
    order: 2!important;
  }
}

.header {
  padding:48px 0 30px 0;
  width: 100%;

  @media screen and (max-width: 1400px) {
    padding:10px;
  }

  .col {
    justify-content: flex-end;

    @media screen and (max-width: 959px){
      justify-content: flex-start;
    }
  }

  svg {
    max-width: 300px;
    width: 100%;

    @media screen and (max-width: 1400px) {
      max-width: 250px;
    }
  }
}

body, .theme--dark.v-application {
  background: #000000 !important;
}

.v-application--wrap {
  min-height: auto!important;
}

.quiz-start {
  background-color: #000000;
  display: flex;
  align-items: center;
  //background-position: right 50px top 50px;
  background-position: right 50px center;
  padding: 0 20px 20px 20px;
  background-size: 25vw;

  @media screen and (max-width: 768px) {
    background-position: top 10px center;
    background-size: 60%;
    padding: 10px;
    /*height: 100vh !important;*/
    height: auto!important;
    align-items: flex-end;
    h1 {
      font-size: 20px;
      margin-top: 50px;
    }

    h2 {
      text-align: center;

      @media screen and (max-width: 959px) {
        text-align: left;
      }
    }
  }

  .txt-col {
    flex-direction: column;
    /*justify-content: center;*/

    h2 {
      /*font-size: 36px;*/
      font-size: clamp(1.625rem,3vw, 2.25rem);
      color: #85BB24;
      font-weight: 100;
      margin-bottom: 16px;
      line-height: initial;

      @media screen and (max-width: 1400px) {
        font-size: clamp(22px,3vw, 26px);
      }
    }

    p,li{
      font-size: 16px;
      @media screen and (max-width: 1400px) {
        font-size: 14px;
      }
    }

    strong {
      color:#85BB24;
    }
  }

}

.quiz-wrapper, .v-stepper__content {
  background: #000000;
  /*min-height: 100vh;*/
  font-family: 'Open Sans', sans-serif;
  @media screen and (max-width: 768px) {
    height: auto;
  }

  .stepper-items {
    height: 100%;
  }

  img {
    width: 100%;
  }

  h1 {
    color: #000000;
    //font-size: 85px;
    font-size: clamp(65px, 5vw, 85px);
    letter-spacing: 0;
    line-height: 1em;
    margin-bottom: 30px;

    @media screen and (max-width: 768px) {
      font-size: 40px;
      text-align: center;
    }

    @media screen and (max-width: 330px) {
      font-size: 20px;
    }
  }

  h2 {
    //font-size: 40px;
    font-size: clamp(30px, 3.5vw, 40px);
    color: #1e1e1e;
    line-height: 1em;
    font-weight: normal;

    @media screen and (max-width: 768px) {
      font-size: 20px;
    }
  }

  .start-btn {
    background-color: #80BD0A;
    //font-size: 50px;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    text-transform: none;
    letter-spacing: 0;
    height: auto !important;
    display: flex;
    align-self: baseline;
    align-content: center;
    align-items: center;
    border-radius: 45px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;

    @media screen and (max-width: 768px) {
      width: 100% !important;
      font-size: 25px;
    }

    img {
      margin-left: 10px;
      /*width: 50px;*/

      @media screen and (max-width: 768px) {
        width: 20px;
      }
    }
  }

  .join-btn {
    background-color: #80BD0A;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    text-transform: none;
    letter-spacing: 0;
    height: auto !important;
    /*display: flex;*/
    align-self: baseline;
    align-content: center;
    align-items: center;
    border-radius: 45px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  .no-padding {
    padding: 0;
  }

  .step-txt {
    height: 100%;
    max-width: 80%;
    width: 100%;
    padding-left: 50px;

    @media screen and (max-width: 1750px){
      max-width: 100%;
      padding-left: 20px;
    }

    @media screen and (max-width: 959px){
      padding-left:0;
    }
  }

  .question-step {
    h2 {
      color: #c00f1b;
      //font-size: 70px;
      font-size: clamp(55px, 4vw, 70px);
      //margin-bottom:60px;
      margin-bottom: 3vh;

      @media screen and (max-width: 768px) {
        font-size: 50px;
        margin-bottom: 30px;
      }

      .steps-count {
        font-size: 60px;
        @media screen and (max-width: 768px) {
          font-size: 40px;
        }
      }
    }

    .v-stepper__wrapper {
      height: 100%;
      width: 100%;
    }

    .question {
      //font-size: 35px;
      line-height: 1em;
      letter-spacing: 0;
      margin-bottom: 50px;
      color:#85BB24;
      font-weight: 100;
      font-size: clamp(18px, 2.5vw, 36px);

      @media screen and (max-width: 1400px) {
        margin-bottom: 20px;
      }

      @media screen and (max-width: 768px) {
        font-size: 25px;
      }
    }

    .question-wrapper {
      padding-left: 50px;
      padding-right: 50px;

      @media screen and (max-width: 1400px) {
        padding-left: 20px;
        padding-right: 20px;
      }

      @media screen and (max-width: 959px) {
        padding-left: 0;
        padding-right: 0;
      }
    }

    .question-footer {
      margin-top:40px;
    }

    .prev-bt {
      font-weight: bold;
      font-size: 23px;
      display: flex;
      align-content: center;
      align-items: center;
      cursor: pointer;
      color:#85BB24;

      img {
        margin-right: 10px;
      }

      svg {
        max-width: 28px;
        margin-right: 23px;
        width: 100%;
      }

      @media screen and (max-width: 1400px) {
        font-size: 18px;
      }

      @media screen and (max-width: 768px) {
        font-size: 24px;
      }
    }

  }

  .img-col {
    justify-content: center;
    align-items: center;
    display: flex;
    img {
      align-self: center;
      max-width: 60%;

      @media screen and (max-width: 1600px) {
        max-width: 70%;
      }

      @media screen and (max-width: 949px) {
        max-width: 90%;
      }
    }
    /*min-height: 100vh;*/
    min-height: unset;
    background-size: cover;
    @media screen and (max-width: 768px) {
      height: auto;
    }
  }

  /*.step-2 {
    .img-col {
      background-image: url('../assets/step-1.png');
    }
  }

  .step-3 {
    .img-col {
      background-image: url('../assets/step-2.png');
    }
  }

  .step-4 {
    .img-col {
      background-image: url('../assets/step-3.png');
    }
  }

  .step-5 {
    .img-col {
      background-image: url('../assets/step-4.png');
    }
  }*/

  .answers {
    list-style: none;
    padding-left:0;

    li {
      margin-bottom: 20px;
      font-size: 26px;
      color: #525455;
      line-height: 1em;
      align-items: center;
      cursor: pointer;

      @media screen and (max-width: 1400px) {
        font-size: 18px;
        margin-bottom: 10px;
      }

      p {
        margin-bottom: 0;
        color: #FFFFFF;
        font-size: 24px;
        transition:all 0.3s;

        @media screen and (max-width: 1400px) {
          font-size: 18px;
        }
      }

      &:hover, &.selected {
        font-weight: 500;
        p {
          color: #85BB24;
        }
      }

      .ico {
        width:28px;
        height: 28px;
        margin-right: 23px;
        flex-shrink: 0;
      }

      .v-avatar {
        margin-right: 10px;

        .answer-label {
          font-weight: bold;
          font-size: 25px;
        }
      }

      &:last-child {
          margin-bottom: 0;
      }

    }

    @media screen and (max-width: 768px) {
      padding-left: 0;
      p {
        font-size: 20px;
      }
    }
  }

  .quiz-end {
    h2 {
      color: #85BB24;
      margin-bottom: 20px;
      font-size: 35px;
      font-weight: 100;
      line-height: 1.4em;

      @media screen and (max-width: 1400px) {
        font-size: clamp(22px,3vw, 26px);
      }

      @media screen and (max-width: 959px) {
        font-size: clamp(22px, 3vw, 26px);
      }

    }

    strong {
      color:#85BB24;
    }

    ul {
      margin-bottom: 20px;
      li {
        color: #FFFFFF;
        font-size: 17px;
        margin-bottom: 5px;
        line-height: 1.2em;
        @media screen and (max-width: 1400px) {
          font-size: 14px;
        }
        &::marker {
          color: #85BB24;
        }
      }

    }

    p {
      color: #FFFFFF;
      font-size: 17px;
      margin-bottom: 20px;
      line-height: 1.2em;

      @media screen and (max-width: 1400px) {
        font-size: 14px;
      }

      .result {
        color: #c00f1b;
        text-transform: uppercase;
      }

      @media screen and (max-width: 959px) {
        font-size: 14px;
      }

    }

    .result-content {
      /*height: 100vh;*/
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    .img-col {
      img {
        // max-width: 100%;
      }
    }

    .question-wrapper-center {
      justify-content: center;
      max-width: 55%;

      @media screen and (max-width: 768px) {
        max-width: 100%;
      }
    }
  }
}
</style>
